import { ApiVersion, MainUrl } from "../../../Api/constants";

const Config = window?.Config || {};

const baseUrl =MainUrl;
const apiPath = ApiVersion;
const chatPath =
  Config?.Routes?.Chat?.Path ||
  Config?.Client?.Chat?.Path ||
  "/Chat";

const ChatRoutingManager = {
  ApiUrl: `${baseUrl}${apiPath}`,
  Client: {
    Chat: {
      Path: chatPath,
    },
  },
};

export default ChatRoutingManager;
